<template>
    <div class="stars">
        <span v-if="rate && starSize == 'large'" ref="stars" class="is-rate">
            <img src="@/assets/img/component/evaluation/star_gray_large.svg" />
            <img src="@/assets/img/component/evaluation/star_gray_large.svg" />
            <img src="@/assets/img/component/evaluation/star_gray_large.svg" />
            <img src="@/assets/img/component/evaluation/star_gray_large.svg" />
            <img src="@/assets/img/component/evaluation/star_gray_large.svg" />
        </span>
        <span v-else-if="rate" ref="stars" class="is-rate">
            <img src="@/assets/img/component/evaluation/star_gray.svg" />
            <img src="@/assets/img/component/evaluation/star_gray.svg" />
            <img src="@/assets/img/component/evaluation/star_gray.svg" />
            <img src="@/assets/img/component/evaluation/star_gray.svg" />
            <img src="@/assets/img/component/evaluation/star_gray.svg" />
        </span>
        <span v-else class="no-rate">沒有評價</span>
    </div>
</template>
<script>
export default {
    data () {
        return {
        }
    },
    props: {
        starSize: String,
        rate: 0,
    },
    mounted () {
        this.setStars(this.rate)
    },
    watch: {
        rate: function (val){
            this.setStars(val)
        }
    },
    methods: {
        setStars: function (rate) {
            // console.log(this.$refs)
                if( this.starSize == 'large' ){
                    if(this.$refs.stars.children){
                        let stars = this.$refs.stars.children
                        for (let i = 0; i < rate; i++) {
                            const star = stars[i];
                            star.src = require('@/assets/img/component/evaluation/star_golden_large.svg')
                        }
                    }
                }else{
                    if(this.$refs.stars.children){
                        let stars = this.$refs.stars.children
                        for (let i = 0; i < rate; i++) {
                            const star = stars[i];
                            star.src = require('@/assets/img/component/evaluation/star_golden.svg')
                        }
                    }
                }
        }
    }
}
</script>
<style   lang="scss">
    .stars{
        .is-rate{
            display: flex;
            align-items: center;
            img{
                margin-right: 2px;
            }
        }
        .no-rate{
            opacity: 0.6;
            color: #ffffff;
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/Evaluation.vue